module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-587.41fa755.woff2";